<template>
  <v-container fluid class="py-0 px-2">
    <v-text-field
      v-model="search"
      background-color="colorSearchSettings"
      clearable
      :append-icon="mdiMagnify"
      :label="$t('label.search')"
      hide-details
    ></v-text-field>
    <div style="min-height: 1px"></div>
    <v-data-table
      :headers="headers"
      :items="tableData"
      item-key="id"
      :height="$store.state.windowSize.y - 150"
      :search="search"
      fixed-header
      must-sort
      disable-pagination
      hide-default-footer
      class="tableCursor"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.name }}</td>
          <td>{{ item.areaNames }}</td>
          <td>{{ item.id }}</td>
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="item.monitorDS || item.monitorQRS || item.monitorIRTS"
                  @click="((dialogMonitoring = true), (monitoringData = item))"
                  icon
                >
                  <v-icon v-on="on">{{ monitoringIcon(item) }}</v-icon>
                </v-btn>
              </template>
              <span v-html="$t('tt.devicesMonitoring')" />
            </v-tooltip>
          </td>
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-if="notGatehouse()" icon>
                  <v-icon v-on="on" @click="changeClientID(item)">{{ mdiEye }}</v-icon>
                </v-btn>
              </template>
              <span v-html="$t('tt.switchWorkplaceView')" />
            </v-tooltip>
          </td>
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="$store.getters.appMode != 'electron'"
                  @click="((modalDownloadClient = true), (workplace = { ...item }), createClientDownloadURL())"
                  icon
                  v-on="on"
                  ><v-icon>{{ mdiDownload }}</v-icon>
                </v-btn>
              </template>
              <span v-html="$t('tt.downloadInstallFile')" />
            </v-tooltip>
          </td>
          <td
            v-if="$store.state.auth.userSettings.accWorkplaces.update"
            class="px-2 tableSelectCursor"
            @click="
              ((newWorkplace = false),
              (deleteButton = true),
              (workplace = { ...item }),
              updateAvailableAreas(),
              filterAvailableColumns(item.tranColumnsArray),
              listEdokladyPrepare(),
              (modalEdit = true))
            "
          >
            <v-icon>{{ mdiPen }}</v-icon>
          </td>
          <td v-else></td>
        </tr>
      </template>
    </v-data-table>
    <v-row>
      <v-col cols="3">
        <v-btn v-if="$store.state.auth.userSettings.accWorkplaces.write" block color="colorNew" @click="dataNew">
          {{ $t('label.addNew') }}
        </v-btn>
      </v-col>
      <v-col cols="2">
        <v-btn
          v-if="$store.state.auth.userSettings.accWorkplaces.write || $store.state.auth.userSettings.accWorkplaces.update"
          block
          color="colorStnBtn1"
          @click="editDefault"
        >
          {{ $t('label.defaultSettings') }}
        </v-btn>
      </v-col>
      <v-spacer />
      <v-col cols="1">
        <v-btn icon @click="dataLoad()">
          <v-icon large>{{ mdiReload }}</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="1">
        <v-icon v-if="$store.state.changeClientID" color="colorDelete" @click="cancelChangeClientID" large>{{ mdiEyeOff }}</v-icon>
      </v-col>
    </v-row>
    <!----------DIALOGS------------------------------>
    <v-dialog v-model="modalEdit" persistent width="70%">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $tc('label.workplace') }} ({{ workplace.id }})
          <v-spacer />
          <v-icon large @click="modalEdit = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text class="pa-3">
          <v-form v-model="validForm" ref="workplaceForm">
            <v-row>
              <v-col cols="6">
                <v-row>
                  <v-col>
                    <v-text-field
                      :label="$t('label.itemName')"
                      :rules="[ruleRequired]"
                      v-model="workplace.name"
                      maxlength="256"
                      hide-details
                      dense
                      autofocus
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-select
                      v-model="workplace.areas"
                      :label="$tc('label.area', 2)"
                      :items="listAreas"
                      item-text="name"
                      item-value="id"
                      :menu-props="{ minWidth: '500' }"
                      :rules="[ruleRequired]"
                      :return-object="false"
                      @change="updateAvailableAreas"
                      multiple
                      chips
                      deletable-chips
                      hide-no-data
                      cache-items
                      auto-select-first
                      hide-details
                      dense
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="6">
                    <v-select
                      v-model="workplace.defaultarea"
                      :label="$t('label.defaultArea')"
                      :items="listAreas"
                      item-text="name"
                      item-value="id"
                      :menu-props="{ minWidth: '500' }"
                      :rules="[ruleRequired]"
                      :return-object="false"
                      append-icon
                      hide-no-data
                      cache-items
                      @change="appendDefaultToAreas"
                      hide-details
                      dense
                    />
                    <v-select
                      v-model="workplace.edType"
                      :label="$tc('label.edoklady')"
                      :items="listEDType"
                      item-text="name"
                      item-value="id"
                      hide-details
                      @change="!workplace.area ? (workplace.areaMandatory = 0) : ''"
                      :disabled="!$store.state.auth.settings.edoklady"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      v-model="workplace.area"
                      :label="$tc('label.workplaceForArea')"
                      :items="listAvailableAreas"
                      item-text="name"
                      item-value="id"
                      :menu-props="{ minWidth: '500' }"
                      :return-object="false"
                      :disabled="workplace.id == '00000000-0000-0000-0000-000000000000'"
                      hide-details
                      dense
                      clearable
                      @change="!workplace.area ? (workplace.areaMandatory = 0) : ''"
                    />
                    <v-select
                      v-model="workplace.areaMandatory"
                      :items="areaRequiredSelect"
                      item-text="name"
                      item-value="value"
                      :disabled="!workplace.area"
                      class="pa-0 ma-0"
                      hide-details
                      dense
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-checkbox class="pa-0 ma-0" v-model="workplace.stayLoggedIn" :label="$t('label.stayLoggedIn')" hide-details />
                    <v-checkbox class="pa-0 ma-0" v-model="workplace.printGuestTicket" :label="$t('label.autoPrintTicket')" hide-details />
                    <v-checkbox
                      class="pa-0 ma-0"
                      v-model="workplace.highlightDiffIDEnter"
                      :label="$t('label.highlightDiffIDEnter')"
                      hide-details
                    />
                    <v-checkbox
                      class="pa-0 ma-0"
                      v-model="workplace.filterEmployees"
                      :label="$t('label.showOnlyWPemployees')"
                      hide-details
                    />
                    <v-checkbox
                      class="pa-0 ma-0"
                      v-model="workplace.plannedVisitsPopup"
                      :label="$t('label.autoOfferPlannedVisits')"
                      hide-details
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="py-0">
                    <h3>{{ $tc('label.deviceMonitoring') }}</h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-1" cols="6">
                    <v-checkbox class="ma-0 pa-0" v-model="workplace.monitorDS" :label="$t('label.documentReader')" hide-details />
                  </v-col>
                  <v-col class="py-1" cols="6">
                    <v-checkbox class="ma-0 pa-0" v-model="workplace.monitorQRS" :label="$t('label.qrCodeReader')" hide-details />
                  </v-col>
                </v-row>
                <!--v-row>
                  <v-col class="py-1" cols="6">
                    <v-checkbox class="ma-0 pa-0" v-model="workplace.monitorIRTS" :label="$t('label.temperatureReader')" hide-details />
                  </v-col>
                </v-row-->
              </v-col>

              <v-col cols="6">
                <v-row no-gutters>
                  <v-col cols="6"></v-col>
                  <v-tooltip bottom :open-delay="300">
                    <template v-slot:activator="{ on }">
                      <v-col v-on="on" cols="2">{{ $t('label.show') }}</v-col>
                    </template>
                    <span>{{ $t('tt.showItemsOnWorkplace') }}</span>
                  </v-tooltip>
                  <v-tooltip bottom :open-delay="300">
                    <template v-slot:activator="{ on }">
                      <v-col v-on="on" cols="2">{{ $t('label.mandatory') }}</v-col>
                    </template>
                    <span>{{ $t('tt.itemMandatory') }}</span>
                  </v-tooltip>
                  <v-tooltip bottom :open-delay="300">
                    <template v-slot:activator="{ on }">
                      <v-col v-on="on" cols="2">{{ $t('label.list') }}</v-col>
                    </template>
                    <span>{{ $t('tt.itemsList') }}</span>
                  </v-tooltip>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="6">
                    <div>{{ $tc('label.employee', 2) }}</div>
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="workplace.employee" />
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="workplace.employeeRequired" />
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="workplace.employeeList" />
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="6">
                    <div>{{ $tc('label.company', 2) }}</div>
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="workplace.company" />
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="workplace.companyRequired" />
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="workplace.companyList" />
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="6">
                    <div>{{ $tc('label.car', 2) }}</div>
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="workplace.cars" />
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="workplace.carsRequired" />
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="workplace.carsList" />
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="6">
                    <div>{{ $tc('label.visitorcard', 2) }}</div>
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="workplace.cards" />
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="workplace.cardsRequired" />
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="workplace.cardsList" />
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="6">
                    <div>{{ $t('label.expire') }}</div>
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="workplace.expire" />
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="workplace.expireRequired" />
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="6">
                    <div>{{ $tc('label.country') }}</div>
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="workplace.country" />
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="workplace.countryRequired" />
                  </v-col>
                </v-row>

                <v-row v-if="$store.state.auth.settings.usrDef1name" no-gutters>
                  <v-col cols="6">
                    <div>{{ $store.state.auth.settings.usrDef1name }}</div>
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="workplace.usrDef1" />
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="workplace.usrDef1Required" />
                  </v-col>
                </v-row>

                <v-row v-if="$store.state.auth.settings.usrDef2name" no-gutters>
                  <v-col cols="6">
                    <div>{{ $store.state.auth.settings.usrDef2name }}</div>
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="workplace.usrDef2" />
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="workplace.usrDef2Required" />
                  </v-col>
                </v-row>

                <v-row v-if="$store.state.auth.settings.usrDef3name" no-gutters>
                  <v-col cols="6">
                    <div>{{ $store.state.auth.settings.usrDef3name }}</div>
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="workplace.usrDef3" />
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="workplace.usrDef3Required" />
                  </v-col>
                </v-row>

                <v-row v-if="$store.state.auth.settings.usrDef4name" no-gutters>
                  <v-col cols="6">
                    <div>{{ $store.state.auth.settings.usrDef4name }}</div>
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="workplace.usrDef4" />
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox class="ma-0 pa-0" hide-details v-model="workplace.usrDef4Required" />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-tooltip bottom :open-delay="300">
                      <template v-slot:activator="{ on }">
                        <b v-on="on">{{ $t('label.rememberOnVisitor') }}</b>
                      </template>
                      <span v-html="$t('tt.rememberOnVisitor')" />
                    </v-tooltip>
                  </v-col>
                </v-row>

                <v-row class="py-0 my-0">
                  <v-col class="py-0 my-0">
                    <v-checkbox
                      :disabled="!workplace.employeeList"
                      v-model="workplace.prefillEmployee"
                      class="pa-0 ma-0"
                      :label="$tc('label.employee', 3)"
                      hide-details
                    />
                  </v-col>
                </v-row>

                <v-row class="py-0 my-0">
                  <v-col class="py-0 my-0">
                    <v-checkbox
                      :disabled="!workplace.companyList"
                      v-model="workplace.prefillCompany"
                      class="pa-0 ma-0"
                      :label="$tc('label.company')"
                      hide-details
                    />
                  </v-col>
                </v-row>

                <v-row class="py-0 my-0">
                  <v-col class="py-0 my-0">
                    <v-checkbox
                      :disabled="!workplace.carsList"
                      v-model="workplace.prefillCar"
                      class="pa-0 ma-0"
                      :label="$tc('label.car')"
                      hide-details
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-select
                      v-model="workplace.report"
                      :label="$t('label.dailyVisitsReport')"
                      :menu-props="{ minWidth: '500' }"
                      :items="listReports"
                      item-text="name"
                      item-value="id"
                      hide-details
                      dense
                      clearable
                      :prepend-inner-icon="mdiPrinter"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn v-if="deleteButton && $store.state.auth.userSettings.accWorkplaces.delete" color="colorDelete" @click="modalDelete = true">
            {{ $t('btn.delete') }}
          </v-btn>
          <v-btn color="colorStnBtn1" @click="modalTranColumns = true">{{ $t('label.columnsInWorkplaceView') }}</v-btn>
          <v-btn
            v-if="workplace.id != '00000000-0000-0000-0000-000000000000'"
            :disabled="!$store.state.auth.settings.autoSaveVisitors"
            color="colorStnBtn1"
            @click="dialogTerminals = true"
          >
            {{ $tc('label.terminal', 2) }}
          </v-btn>
          <v-spacer />
          <v-btn color="colorSave" @click="dataSave">{{ $t('btn.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalDownloadClient" max-width="60vw">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>{{ $t('label.downloadInstallFile') }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col class="my-2">
              <v-form :action="clientDownloadLinkWindows">
                <input type="hidden" name="url" :value="clientDownloadServerURL" />
                <v-btn block type="submit" color="colorExport" @click="modalDownloadClient = false">
                  {{ $t('btn.downloadWindows') }}
                </v-btn>
              </v-form>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="my-2">
              <v-form :action="clientDownloadLinkMacIntel">
                <input type="hidden" name="url" :value="clientDownloadServerURL" />
                <v-btn block type="submit" color="colorExport" @click="modalDownloadClient = false">
                  {{ $t('btn.downloadMacOSintel') }}
                </v-btn>
              </v-form>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="my-2">
              <v-form :action="clientDownloadLinkMacAppleSilicon">
                <input type="hidden" name="url" :value="clientDownloadServerURL" />
                <v-btn block type="submit" color="colorExport" @click="modalDownloadClient = false">
                  {{ $t('btn.downloadMacOSapple') }}
                </v-btn>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="colorClose" @click="modalDownloadClient = false">{{ $t('btn.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalTranColumns" max-width="60vw">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>{{ $t('label.columnsInWorkplaceView') }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-card min-height="70vh">
                <v-card-title>{{ $t('label.columnsAvailable') }}</v-card-title>
                <v-card-text>
                  <draggable
                    style="background-color: #f2f2f2; height: 60vh"
                    class="dragArea list-group tableSelectCursor"
                    :list="filteredAvailableColumns"
                    :group="{ name: 'people', pull: pullFunction }"
                    @start="start"
                  >
                    <div
                      style="background-color: #ddf4ff"
                      class="list-group-item elevation-2"
                      v-for="element in filteredAvailableColumns"
                      :key="element.id"
                    >
                      <b>{{ element.name }}</b>
                    </div>
                  </draggable>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card min-height="70vh">
                <v-card-title>{{ $t('label.columnsSelected') }}</v-card-title>
                <v-card-text>
                  <draggable
                    style="background-color: #f2f2f2; height: 60vh"
                    class="dragArea list-group tableSelectCursor"
                    :list="workplace.tranColumnsArray"
                    group="people"
                  >
                    <div
                      style="background-color: #ddffdd"
                      class="list-group-item elevation-2"
                      v-for="element in workplace.tranColumnsArray"
                      :key="element.id"
                    >
                      <span style="display: inline-block; width: 50%">
                        <b>{{ element.name }}</b>
                      </span>
                      <span style="display: inline-block; width: 20%">{{ $t('label.width') }}</span>
                      <span style="display: inline-block; width: 30%">
                        <input type="text" style="background-color: white; width: 100%; border: 1px solid" v-model="element.width" />
                      </span>
                    </div>
                  </draggable>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn tile color="colorClose" @click="modalTranColumns = false">{{ $t('btn.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogTerminals" max-width="800" persistent>
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $tc('label.terminal', 1) }}
          <v-spacer />
          <v-icon large @click="dialogTerminals = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="7">
              <v-text-field v-model="terminalName" :label="$t('label.name')" hide-details />
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="selectedSigLanguage"
                :items="signTermLangs"
                :return-object="false"
                item-text="name"
                item-value="code"
                :label="$t('label.language')"
                hide-details
              />
            </v-col>
            <v-col cols="3">
              <v-btn block class="mt-3" @click="appendTerminal">{{ $t('btn.add') }}</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-list width="100%" height="255px" elevation="1" style="overflow: auto; text-overflow: hidden">
              <v-list-item v-for="item in workplace.terminals" :key="item.id">
                <v-col cols="7">
                  <v-text-field v-model="item.name" hide-details dense />
                </v-col>
                <v-col cols="2">
                  <v-select
                    v-model="item.language"
                    :items="signTermLangs"
                    :return-object="false"
                    item-text="name"
                    item-value="code"
                    :label="$t('label.language')"
                    hide-details
                    dense
                  />
                </v-col>
                <v-col cols="1">
                  <v-simple-checkbox v-model="item.active" hide-details />
                </v-col>
                <v-col cols="1">
                  <v-btn icon @click="createTermURL(item.id)">
                    <v-icon color="green">{{ mdiClipboardText }}</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="1">
                  <v-btn icon @click="((dialogDeleteTerminal = true), (selectedTerminal = item))">
                    <v-icon color="red">{{ mdiDelete }}</v-icon>
                  </v-btn>
                </v-col>
              </v-list-item>
            </v-list>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogMonitoring" max-width="550" persistent>
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $tc('label.deviceMonitoring') }}
          <v-spacer />
          <v-icon large @click="dialogMonitoring = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text>
          <v-spacer class="py-2" />
          <v-row>
            <v-col cols="6">
              <h2>{{ $t('label.device') }}</h2>
            </v-col>
            <v-col cols="2">
              <h2>{{ $t('label.state') }}</h2>
            </v-col>
            <v-col cols="4">
              <h2>{{ $t('label.version') }}</h2>
            </v-col>
          </v-row>
          <v-divider />
          <v-spacer class="py-2" />
          <v-row v-if="monitoringData.monitorDS">
            <v-col cols="6">
              <h3>{{ $t('label.documentReader') }}</h3>
            </v-col>
            <v-col cols="2">
              <v-icon v-if="monitoringData.statusDS == 'OK'" color="green">{{ mdiCheckBold }}</v-icon>
              <v-icon v-else-if="monitoringData.statusDS == 'ERROR'" color="red">{{ mdiCloseThick }}</v-icon>
              <v-icon v-else>{{ mdiHelp }}</v-icon>
            </v-col>
            <v-col cols="4">
              <h3>{{ monitoringData.versionDS }}</h3>
            </v-col>
          </v-row>
          <v-row v-if="monitoringData.monitorQRS">
            <v-col cols="6">
              <h3>{{ $t('label.qrCodeReader') }}</h3>
            </v-col>
            <v-col cols="2">
              <v-icon v-if="monitoringData.statusQRS == 'OK'" color="green">{{ mdiCheckBold }}</v-icon>
              <v-icon v-else-if="monitoringData.statusQRS == 'ERROR'" color="red">{{ mdiCloseThick }}</v-icon>
              <v-icon v-else>{{ mdiHelp }}</v-icon>
            </v-col>
            <v-col cols="4">
              <h3>{{ monitoringData.versionQRS }}</h3>
            </v-col>
          </v-row>
          <v-row v-if="monitoringData.monitorIRTS">
            <v-col cols="6">
              <h3>{{ $t('label.temperatureReader') }}</h3>
            </v-col>
            <v-col cols="2">
              <v-icon v-if="monitoringData.statusIRTS == 'OK'" color="green">{{ mdiCheckBold }}</v-icon>
              <v-icon v-else-if="monitoringData.statusIRTS == 'ERROR'" color="red">{{ mdiCloseThick }}</v-icon>
              <v-icon v-else>{{ mdiHelp }}</v-icon>
            </v-col>
            <v-col cols="4">
              <h3>{{ monitoringData.versionIRTS }}</h3>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogTerminalQR" max-width="400px">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          <v-spacer />
          <v-icon large @click="dialogTerminalQR = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text>
          <v-row justify="center">
            <v-col>
              <v-img width="350px" height="350px" :src="`/api/v1/createqr?text=${encodeURIComponent(terminalURL)}`" />
              {{ terminalURL }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
      </v-card>
    </v-dialog>

    <DialogConfirmDelete
      :header="$t('label.delete')"
      :body="`${$t('msg.confirmDelete')}: ${workplace.name}?`"
      :openDialog.sync="modalDelete"
      v-on:confirm="dataDelete"
    />
    <DialogConfirmDelete
      :header="$t('label.delete')"
      :body="`${$t('msg.confirmDelete')}?`"
      :openDialog.sync="dialogDeleteTerminal"
      v-on:confirm="workplace.terminals.splice(workplace.terminals.indexOf(selectedTerminal), 1)"
    />
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import draggable from 'vuedraggable';
import DialogConfirmDelete from '@/components/DialogConfirmDelete.vue';

import {
  mdiMagnify,
  mdiDownload,
  mdiPen,
  mdiEye,
  mdiEyeOff,
  mdiClose,
  mdiHelp,
  mdiCheckBold,
  mdiCloseThick,
  mdiReload,
  mdiPrinter,
  mdiDelete,
  mdiClipboardText,
} from '@mdi/js';

export default Vue.extend({
  name: 'SettingsEmployees',
  components: {
    draggable,
    DialogConfirmDelete,
  },
  data: () => ({
    tableData: [],
    listAreas: [],
    modalEdit: false,
    modalDelete: false,
    modalDownloadClient: false,
    modalTranColumns: false,
    dialogDeleteTerminal: false,
    dialogTerminalQR: false,
    selectedTerminal: {},
    dialogMonitoring: false,
    dialogTerminals: false,
    signTermLangs: [{ name: '', code: '' }],
    selectedSigLanguage: '',
    monitoringData: {
      monitorDS: false,
      statusDS: '',
      versionDS: '',
      monitorQRS: false,
      statusQRS: '',
      versionQRS: '',
      monitorIRTS: false,
      statusIRTS: '',
      versionIRTS: '',
    },
    clientDownloadServerURL: '',
    clientDownloadLinkWindows: '',
    clientDownloadLinkMacIntel: '',
    clientDownloadLinkMacAppleSilicon: '',
    deleteButton: false,
    newWorkplace: false,
    validForm: false,
    search: '',
    listReports: [],
    listAvailableAreas: [],
    listEDType: [{ name: '', id: '' }],
    terminalName: '',
    terminalURL: '',
    workplace: {
      id: '',
      areas: [],
      areaname: '',
      name: null,
      stayLoggedIn: false,
      cards: false,
      cardsList: false,
      cardsRequired: false,
      cars: false,
      carsList: false,
      carsRequired: false,
      expire: false,
      expireRequired: false,
      country: false,
      countryRequired: false,
      employee: false,
      employeeList: false,
      employeeRequired: false,
      company: false,
      companyList: false,
      companyRequired: false,
      defaultarea: 0,
      usrDef1: false,
      usrDef1Required: false,
      usrDef2: false,
      usrDef2Required: false,
      usrDef3: false,
      usrDef3Required: false,
      usrDef4: false,
      usrDef4Required: false,
      printGuestTicket: false,
      tranColumns: '',
      tranColumnsArray: [],
      prefillEmployee: false,
      prefillCompany: false,
      prefillCar: false,
      highlightDiffIDEnter: false,
      monitorDS: false,
      monitorQRS: false,
      monitorIRTS: false,
      statusDS: '',
      statusQRS: '',
      statusIRTS: '',
      versionDS: '',
      versionQRS: '',
      versionIRTS: '',
      report: 0,
      filterEmployees: false,
      plannedVisitsPopup: false,
      area: 0,
      areaMandatory: 0, // 0=NotRequired, 1=Enter, 2=Enter,Exit
      terminals: [],
      edType: '', // printer, display, 'terminalUUID' (eDoklady)
    },
    availableColumns: [
      { name: 'Příchod', id: 2, text: 'Příchod', value: 'timeenter', align: 'left', width: '100' },
      { name: 'Odchod', id: 3, text: 'Odchod', value: 'timeexit', align: 'left', width: '100' },
      { name: 'Vrátnice Příchod', id: 4, text: 'P.Přích.', value: 'workplaceNameEnter', align: 'left', width: '100' },
      { name: 'Vrátnice Odchod', id: 5, text: 'P.Odch.', value: 'workplaceNameExit', align: 'left', width: '100' },
      {
        name: 'Čas',
        id: 6,
        text: 'Čas',
        value: 'timeInObject',
        align: 'left',
        width: '100',
        sortable: false,
      },
      { name: 'Jméno', id: 7, text: 'Jméno', value: 'name', align: 'left', width: '100' },
      { name: 'Příjmení', id: 8, text: 'Příjmení', value: 'surname', align: 'left', width: '100' },
      { name: 'Země', id: 9, text: 'Země', value: 'country', align: 'left', width: '100' },
      { name: 'Typ (dokladu)', id: 10, text: 'Typ', value: 'documenttype', align: 'left', width: '100' },
      { name: 'Číslo (dokladu)', id: 11, text: 'Číslo', value: 'documentno', align: 'left', width: '100' },
      { name: 'Expirace', id: 12, text: 'Expirace', value: 'expire', align: 'left', width: '100' },
      { name: 'Prostor', id: 13, text: 'Prostor', value: 'area.name', align: 'left', width: '100' },
      { name: 'Vozidlo', id: 14, text: 'Vozidlo', value: 'car.plate', align: 'left', width: '100' },
      {
        name: 'Za kým (Jméno)',
        id: 15,
        text: 'Zam.Jm.',
        value: 'employee.name',
        align: 'left',
        width: '100',
      },
      {
        name: 'Za kým (Příjmení)',
        id: 16,
        text: 'Zam.Pr.',
        value: 'employee.surname',
        align: 'left',
        width: '100',
      },
      {
        name: 'Za kým (Oddělení)',
        id: 17,
        text: 'Zam.Od.',
        value: 'employee.department',
        align: 'left',
        width: '100',
      },
      {
        name: 'Za kým (Telefon)',
        id: 18,
        text: 'Zam.Tel.',
        value: 'employee.phone',
        align: 'left',
        width: '100',
      },
      { name: 'Firma', id: 19, text: 'Firma', value: 'company.name', align: 'left', width: '100' },
      {
        name: 'Karta',
        id: 20,
        text: 'Karta',
        value: 'visitorcard.identifier',
        align: 'left',
        width: '100',
      },
      { name: 'Poznámka', id: 21, text: 'Poznámka', value: 'note', align: 'left', width: '160' },
      { name: 'Pořadí za prostor', id: 22, text: 'p.Pros.', value: 'countPerArea', align: 'left', width: '100' },
      { name: 'Pořadí za vrátnici', id: 23, text: 'p.Vr.', value: 'countPerWorkplace', align: 'left', width: '100' },
      { name: 'Plánoval-orgID', id: 40, text: 'pl.orgID.', value: 'pbOrgID', align: 'left', width: '100' },
      { name: 'Plánoval-Jméno', id: 41, text: 'pl.Jméno.', value: 'pbName', align: 'left', width: '100' },
      { name: 'Plánoval-Příjmení', id: 42, text: 'pl.Příj.', value: 'pbSurname', align: 'left', width: '100' },
      { name: 'Schválil-orgID', id: 60, text: 'sch.orgID.', value: 'abOrgID', align: 'left', width: '100' },
      { name: 'Schválil-Jméno', id: 61, text: 'sch.Jméno.', value: 'abName', align: 'left', width: '100' },
      { name: 'Schválil-Příjmení', id: 62, text: 'sch.Příj.', value: 'abSurname', align: 'left', width: '100' },
    ],
    filteredAvailableColumns: [{ id: 0, name: '' }],
    controlOnStart: true,
    mdiMagnify: mdiMagnify,
    mdiDownload: mdiDownload,
    mdiPen: mdiPen,
    mdiEye: mdiEye,
    mdiClose: mdiClose,
    mdiEyeOff: mdiEyeOff,
    mdiHelp: mdiHelp,
    mdiCheckBold: mdiCheckBold,
    mdiCloseThick: mdiCloseThick,
    mdiReload: mdiReload,
    mdiPrinter: mdiPrinter,
    mdiDelete: mdiDelete,
    mdiClipboardText: mdiClipboardText,
  }),
  computed: {
    ruleRequired() {
      return (v: any) => !!v || this.$i18n.t('msg.fieldIsMandatory');
    },
    areaRequiredSelect() {
      var areaRequiredSelect: any = [
        { name: this.$i18n.tc('label.notRequired'), value: 0 },
        { name: this.$i18n.tc('label.enter'), value: 1 },
        { name: `${this.$i18n.tc('label.enter')}, ${this.$i18n.tc('label.exit')}`, value: 2 },
        { name: this.$i18n.t('label.requireExitIfEnter'), value: 3 },
      ];
      return areaRequiredSelect;
    },
    headers() {
      var headers: any = [
        { text: this.$i18n.t('label.itemName'), value: 'name' },
        { text: this.$i18n.tc('label.area', 2), value: 'areaname' },
        { text: this.$i18n.t('label.UUID'), value: 'id' },
        { text: this.$i18n.tc('label.deviceMonitoring', 2), sortable: false, width: '48px' },
        { sortable: false, width: '48px' },
        { sortable: false, width: '48px' },
        { sortable: false, width: '48px' },
      ];
      return headers;
    },
  },
  mounted() {
    this.listAreasLoad();
    this.listReportsLoad();
    this.listSignTermLangsLoad();
    this.$nextTick(function () {
      this.dataLoad();
    });
  },
  methods: {
    monitoringIcon(item: any) {
      if (
        (item.monitorDS && item.statusDS !== 'OK') ||
        (item.monitorQRS && item.statusQRS !== 'OK') ||
        (item.monitorIRTS && item.statusIRTS !== 'OK')
      ) {
        return this.mdiCloseThick;
      }
      return this.mdiCheckBold;
    },
    dataLoad() {
      this.tableData = [];
      axios
        .get(`/api/v1/workplace`)
        .then((response) => {
          let workplace: {
            areas: [];
            areaNames: string;
            tranColumns: string;
            tranColumnsArray: [];
          };
          for (workplace of response.data) {
            workplace.tranColumnsArray = JSON.parse(workplace.tranColumns);
            let header = {} as any;
            for (header of workplace.tranColumnsArray) {
              header.name = this.$t(`colTran.name.${header.value}`);
              header.text = this.$t(`colTran.text.${header.value}`);
            }
            workplace.areaNames = '';
            for (const area of workplace.areas) {
              let listArea: any;
              for (listArea of this.listAreas) {
                if (listArea.id === area) {
                  workplace.areaNames = workplace.areaNames + ', ' + listArea.name;
                  break;
                }
              }
            }
            workplace.areaNames = workplace.areaNames.substring(2);
          }
          this.tableData = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },

    dataNew() {
      axios
        .get('/api/v1/workplace/00000000-0000-0000-0000-000000000000')
        .then((response) => {
          this.workplace = response.data;
          axios
            .get('/api/v1/uuid')
            .then((response) => {
              this.workplace.id = response.data.uuid;
              this.workplace.tranColumnsArray = JSON.parse(this.workplace.tranColumns);
              this.filterAvailableColumns(this.workplace.tranColumnsArray);
              this.workplace.areas = [];
              this.newWorkplace = true;
              this.deleteButton = false;
              this.modalEdit = true;
              this.listEdokladyPrepare();
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    dataSave() {
      const form: any = this.$refs.workplaceForm;
      if (form.validate() !== true) {
        this.$store.commit('globalMessage', this.$i18n.t('msg.formNotValid'));
      } else {
        this.appendDefaultToAreas();
        this.workplace.tranColumns = JSON.stringify(this.workplace.tranColumnsArray);
        if (this.newWorkplace === true) {
          axios
            .post('/api/v1/workplace', this.workplace)
            .then((response) => {
              if (response.data.status === 'recordExists') {
                this.$store.commit('globalMessage', this.$i18n.t('msg.itemNameExists'));
              } else {
                this.dataLoad();
                this.modalEdit = false;
              }
              if (localStorage.getItem('clientID') !== null && localStorage.getItem('clientID') !== '') {
                this.$store.dispatch('getWorkplaceSettings');
              }
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        } else {
          axios
            .put('/api/v1/workplace', this.workplace)
            .then((response) => {
              if (response.data.status === 'recordExists') {
                this.$store.commit('globalMessage', this.$i18n.t('msg.itemNameExists'));
              } else {
                this.dataLoad();
                this.modalEdit = false;
              }
              if (localStorage.getItem('clientID') !== null && localStorage.getItem('clientID') !== '') {
                this.$store.dispatch('getWorkplaceSettings');
              }
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        }
      }
    },
    dataDelete() {
      axios
        .delete(`/api/v1/workplace/${this.workplace.id}`)
        .then(() => {
          this.dataLoad();
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
      this.modalDelete = false;
      this.modalEdit = false;
    },
    editDefault() {
      axios
        .get('/api/v1/workplace/00000000-0000-0000-0000-000000000000')
        .then((response) => {
          this.workplace = response.data;
          this.workplace.tranColumnsArray = JSON.parse(this.workplace.tranColumns);
          this.filterAvailableColumns(this.workplace.tranColumnsArray);
          this.newWorkplace = false;
          this.deleteButton = false;
          this.modalEdit = true;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    listAreasLoad() {
      axios
        .get('/api/v1/area')
        .then((response) => {
          this.listAreas = response.data;
        })
        .catch((err) => console.log('areasError', err.data));
    },
    updateAvailableAreas() {
      this.listAvailableAreas = [];
      this.workplace.areas.forEach((area: any) => {
        for (const wpArea of this.listAreas) {
          if (wpArea.id === area) {
            console.log('updateAvailableAreas');
            this.listAvailableAreas.push(wpArea);
            break;
          }
        }
      });
    },
    appendDefaultToAreas() {
      for (const area of this.workplace.areas) {
        if (this.workplace.defaultarea === area) {
          return;
        }
      }
      this.workplace.areas.push(this.workplace.defaultarea);
    },
    filterAvailableColumns(columnsSelected: any) {
      this.filteredAvailableColumns = [];
      for (const aColumn of this.availableColumns) {
        let found = false;
        for (const column of columnsSelected) {
          if (column.id === aColumn.id) {
            found = true;
            break;
          }
        }
        if (found === false) {
          this.filteredAvailableColumns.push(aColumn);
        }
      }
    },
    createClientDownloadURL() {
      let port = window.location.port;
      if (port === '') {
        if (window.location.protocol === 'http:') {
          port = '80';
        } else {
          port = '443';
        }
      }
      const url = window.location.protocol + `//` + window.location.hostname + `:` + port;
      this.clientDownloadLinkWindows = `/download/client/${this.workplace.id}/windows`;
      this.clientDownloadLinkMacIntel = `/download/client/${this.workplace.id}/mac-intel`;
      this.clientDownloadLinkMacAppleSilicon = `/download/client/${this.workplace.id}/mac-applesilicon`;
      this.clientDownloadServerURL = url;
    },
    pullFunction() {
      return this.controlOnStart ? 'clone' : true;
    },
    start({ originalEvent }: any) {
      this.controlOnStart = originalEvent.ctrlKey;
    },
    notGatehouse() {
      if (localStorage.getItem('clientID') === null || localStorage.getItem('clientID') === '') {
        return true;
      }
      return false;
    },
    changeClientID(workplace: any) {
      this.$store.commit('wPlaceSettings', workplace);
      this.$store.commit('clientID', workplace.id);
      this.$store.commit('changeClientID', true);
    },
    cancelChangeClientID() {
      this.$store.commit('wPlaceSettings', {});
      this.$store.commit('clientID', '');
      this.$store.commit('changeClientID', false);
    },
    listReportsLoad() {
      axios
        .get('/api/v1/template')
        .then((response) => {
          this.listReports = [];
          for (const item of response.data) {
            if (item.type === 'currentTransactions') {
              this.listReports.push(item);
            }
          }
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    listSignTermLangsLoad() {
      axios
        .get('/api/v1/signtermlangs')
        .then((response) => {
          this.signTermLangs = [];
          let termLang = {} as any;
          for (termLang of Object.entries(response.data)) {
            let lang = { code: termLang[1].langID, name: termLang[1].langName };
            this.signTermLangs.push(lang);
          }
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    async appendTerminal() {
      if (this.terminalName === '') {
        this.$store.commit('globalMessage', `${this.$i18n.t('msg.fieldIsMandatory')}-${this.$i18n.tc('label.name', 1)}`);
        return;
      }
      if (this.selectedSigLanguage === '') {
        this.$store.commit('globalMessage', `${this.$i18n.t('msg.fieldIsMandatory')}-${this.$i18n.t('label.language')}`);
        return;
      }

      this.workplace.terminals === null ? (this.workplace.terminals = []) : '';
      await axios
        .get('/api/v1/uuid')
        .then((response) => {
          this.workplace.terminals.push({
            id: response.data.uuid,
            name: this.terminalName,
            active: true,
            language: this.selectedSigLanguage,
          });
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
      this.terminalName = '';
    },
    createTermURL(termUUID: string) {
      this.terminalURL = `${window.location.origin}/terminal/#/?uuid=${termUUID}`;
      // this.terminalURL = `http://192.168.1.226:8082/#/?uuid=${termUUID}`; // for testing
      this.dialogTerminalQR = true;
    },
    listEdokladyPrepare() {
      this.listEDType = [{ name: '', id: '' }];
      this.listEDType.push({ name: this.$i18n.tc('label.printer'), id: 'printer' });
      // this.listEDoklady.push({ name: 'Display', id: 'display' });
      this.workplace.terminals.forEach((terminal: any) => {
        this.listEDType.push({ name: this.$i18n.tc('label.terminal') + ' - ' + terminal.name, id: terminal.id });
      });
    },
  },
});
</script>
